import React, { PropsWithoutRef, useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Typography,
  Button,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import LanguageIcon from "@mui/icons-material/Language";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useNavigate } from "react-router-dom";
import { SIDEBAR_WIDTH } from "../constants";
import secureLocalStorage from "react-secure-storage";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import "./Layout.scss";
import { useLazyGetUserQuery, usePostLogoutMutation } from "../services/auth";
import {
  getFromStorage,
  removeFromStorage,
  setToStorage,
} from "../helpers/storage";
import { STORAGE_KEYS } from "../constants/storageKeys";
import { resetAuth, setCredentials } from "../reducers/authSlice";
import Loader from "../constants/Loader";
import { useAppDispatch } from "../hooks/store";
import useAuth from "../hooks/useAuth";
import LogoutModal from "../components/modals";
import { useLanguageContext } from "../context/Language";
import useTranslation from "../hooks/traslation";
import CommissionModal from "../components/modals/CommissionModal";
import {
  NotificationResponse,
  useLazyGetHeaderNotificationQuery,
} from "../services/notification";
import { showError } from "../constants/toasts";
import moment from "moment";

interface Props {
  handleSidebarToggle: () => void;
}

function Topbar({ handleSidebarToggle }: PropsWithoutRef<Props>) {
  const navigate = useNavigate();
  const translation = useTranslation();

  const { language, changeLanguage } = useLanguageContext();

  const dispatch = useAppDispatch();
  const [logoutMethod] = usePostLogoutMutation();
  const [getUser, { isLoading }] = useLazyGetUserQuery();
  const [openLogout, setOpenLogout] = useState<boolean>(false);
  const [openCommission, setOpenCommission] = useState<boolean>(false);
  const [getNotification] = useLazyGetHeaderNotificationQuery();
  const [rows, setRows] = useState<NotificationResponse[]>([]);
  const [count, setCount] = useState();

  const getNotificationData = async () => {
    try {
      const res = await getNotification({
        page: 1,
        type: 1,
        limit: 10,
        search: "",
      }).unwrap();
      if (res.statusCode === 200) {
        setCount(res?.data?.totalNotification);
        setRows(res?.data?.notificationData || []);
      }
    } catch (error: any) {
      showError(error?.data?.message);
    } finally {
    }
  };
  const handleLogout = async () => {
    try {
      const result = await logoutMethod({}).unwrap();
      if (result?.statusCode === 200) {
        removeFromStorage(STORAGE_KEYS.token);
        dispatch(resetAuth());
        secureLocalStorage.removeItem("permissions");
        secureLocalStorage.removeItem("role");
        removeFromStorage(STORAGE_KEYS.tempToken);
        navigate("/", { replace: true });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  const [scroll, setScroll] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [anchorElLang, setAnchorElLang] = React.useState<null | HTMLElement>(
    null
  );

  const getLang = getFromStorage(STORAGE_KEYS.language);
  const openLang = Boolean(anchorElLang);
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };

  const handleClickLang = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElLang(event.currentTarget);
  };
  const handleCloseLang = () => {
    setAnchorElLang(null);
  };

  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const getUserDetails = async () => {
    const token = getFromStorage(STORAGE_KEYS.token);

    if (token) {
      try {
        const result = await getUser({}).unwrap();
        if (result?.statusCode === 200 && token) {
          dispatch(
            setCredentials({
              token: `${token}`,
              user: result?.data,
            })
          );
        }
      } catch (error: any) {
        console.log(error);
      }
    }
  };
  const user = useAuth();

  const change = () => {
    const body = document.body; // Use document.body directly to get the body element

    if (body) {
      const language = getFromStorage(STORAGE_KEYS.language);
      const isArabic = language === "ar";

      // Remove the opposite class before adding the new one
      body.classList.remove(isArabic ? "english_lang" : "arabic_lang");
      body.classList.add(isArabic ? "arabic_lang" : "english_lang");
    }
  };

  const handleLangChange = (val: string) => {
    setTimeout(() => {
      // Perform other actions after the page is reloaded
      window.location.reload();
      setToStorage(STORAGE_KEYS.language, val);
      changeLanguage(val);
      setAnchorElLang(null);
    }, 500);
  };

  useEffect(() => {
    change();
  }, [getLang]);

  useEffect(() => {
    const token = getFromStorage(STORAGE_KEYS.token);
    console.log("token: ", token);
    const userData = getFromStorage(STORAGE_KEYS.credentials);
    console.log("userData: ", userData);

    if (token) {
      dispatch(
        setCredentials({
          token: `${token}`,
          user: JSON.parse(`${userData}`),
        })
      );
      getUserDetails();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  }, []);
  useEffect(() => {
    getNotificationData();
  }, []);

  return (
    <Box className="site_header">
      <Loader isLoading={isLoading} />
      <AppBar
        position="fixed"
        className="topbar"
        sx={{
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
          ml: { lg: `${SIDEBAR_WIDTH}px` },
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <div className="topbar_left"></div>
          <div className="topbar_right">
            {/* <Box
              sx={{
                mr: getLang === "en" ? 2 : 0,
                ml: getLang === "ar" ? 2 : 0,
              }}
            >
              <IconButton
                className="notification_btn"
                aria-controls={openLang ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={openLang ? "true" : undefined}
                onClick={handleClickLang}
              >
                <LanguageIcon />
              </IconButton>
              <Menu
                className="notiDropdown_menu"
                id="basic-menu1"
                anchorEl={anchorElLang}
                open={openLang}
                onClose={handleCloseLang}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 20,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem value="en" onClick={(e) => handleLangChange("en")}>
                  English
                </MenuItem>
                <MenuItem value="ar" onClick={(e) => handleLangChange("ar")}>
                  Arabic
                </MenuItem>
              </Menu>
            </Box> */}
            <Box>
              <IconButton
                className="icon_btn"
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={handleClick1}
              >
                <NotificationsActiveIcon />
              </IconButton>
              <Menu
                className="notiDropdown_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 20,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Box className="noti_head">
                  <Typography component="h2">Notifications</Typography>
                  {rows?.length > 3 && (
                    <Button
                      className="btn btn_primary sm"
                      onClick={() => navigate("/recieved-notifications")}
                    >
                      See All
                    </Button>
                  )}
                </Box>
                <ul className="noti_list">
                  {rows?.length
                    ? rows?.map((item) => (
                        <li key={item?._id}>
                          <figure>
                            <img
                              src={
                                item?.image ||
                                "/static/images/user_placeholder.png"
                              }
                              alt=""
                            />
                          </figure>
                          <div className="noti_info">
                            <Typography component="h3">
                              {item?.title || "-"}
                              <Typography component="span">
                                {/* {moment(item?.createdAt, "YYYYMMDD").fromNow()} */}
                              </Typography>
                            </Typography>
                            <Typography component="p">
                              {item?.message || "-"}
                            </Typography>
                          </div>
                        </li>
                      ))
                    : null}
                </ul>
              </Menu>
            </Box>

            <Box>
              <IconButton
                className="topbar_user_btn"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <img
                  src={user?.image || "/static/images/user_placeholder.png"}
                  alt=""
                />
              </IconButton>
              <Menu
                className="userDropdown_menu"
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 15,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => navigate("/manage-profile")}
                >
                  <IconButton className="drpdwn_icns">
                    <PersonIcon />
                  </IconButton>
                  {translation.auth.myProfile}
                </MenuItem>

                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => navigate("/manage-profile/change-password")}
                >
                  <IconButton className="drpdwn_icns">
                    <LockIcon />
                  </IconButton>
                  {translation.auth.changePass}
                </MenuItem>

                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => setOpenCommission(true)}
                >
                  <IconButton className="drpdwn_icns">
                    <AttachMoneyIcon />
                  </IconButton>
                  Commission
                </MenuItem>

                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => setOpenLogout(true)}
                >
                  <IconButton className="drpdwn_icns">
                    <LogoutIcon />
                  </IconButton>
                  {translation.auth.Logout}
                </MenuItem>
              </Menu>
            </Box>
          </div>
        </Toolbar>
      </AppBar>
      <LogoutModal
        openLogout={openLogout}
        setOpenLogout={setOpenLogout}
        handleLogout={handleLogout}
      />
      <CommissionModal open={openCommission} setOpen={setOpenCommission} />
    </Box>
  );
}

export default Topbar;
